/**
 * zIndex for theme
 */
const zIndex = Object.freeze({
  snackbar: 1500,
  tooltip: 1600,
})

export default zIndex
